import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { colors as Colors } from '../../themes/Colors';

import { SVGComponentProps } from '../type';

const EnrollmentPaymentStepIcon: React.FC<SVGComponentProps> = ({
  width = 20,
  height = 20,
  stroke = Colors['light-red-900'],
  ...props
}) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={13}
      viewBox="0 0 15 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.36979 5.36662V8.03328M11.3698 4.03328V6.69995M10.7031 0.699951C12.3356 0.699951 13.2185 0.949792 13.6579 1.14358C13.7164 1.16939 13.7456 1.18229 13.8301 1.26287C13.8807 1.31116 13.973 1.45288 13.9968 1.51868C14.0365 1.62844 14.0365 1.68844 14.0365 1.80845V8.97405C14.0365 9.57989 14.0365 9.88281 13.9456 10.0385C13.8532 10.1969 13.7641 10.2705 13.5911 10.3314C13.421 10.3912 13.0778 10.3253 12.3912 10.1934C11.9107 10.1011 11.3408 10.0333 10.7031 10.0333C8.70312 10.0333 6.70312 11.3666 4.03646 11.3666C2.40399 11.3666 1.52104 11.1168 1.08171 10.923C1.02321 10.8972 0.993954 10.8843 0.909525 10.8037C0.858916 10.7554 0.766537 10.6137 0.742772 10.5479C0.703125 10.4381 0.703125 10.3781 0.703125 10.2581L0.703125 3.09252C0.703125 2.48667 0.703125 2.18375 0.793977 2.02805C0.886393 1.86966 0.975519 1.79603 1.1485 1.73516C1.31855 1.67532 1.66181 1.74127 2.34834 1.87318C2.82887 1.96551 3.39878 2.03328 4.03646 2.03328C6.03646 2.03328 8.03646 0.699951 10.7031 0.699951ZM9.03646 6.03328C9.03646 6.95376 8.29027 7.69995 7.36979 7.69995C6.44932 7.69995 5.70312 6.95376 5.70312 6.03328C5.70312 5.11281 6.44932 4.36662 7.36979 4.36662C8.29027 4.36662 9.03646 5.11281 9.03646 6.03328Z"
        stroke="#7F1D1D"
        strokeWidth={1.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SVGUniqueID>
);

export { EnrollmentPaymentStepIcon };
